module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_right_arrow2.a46f3.png";